require('./bootstrap');

document.addEventListener('contextmenu', function (event) {
    event.preventDefault(); 
});

document.addEventListener('selectstart', function (event) {
    event.preventDefault(); 
});

document.addEventListener('copy', function (event) {
    event.preventDefault();
});

document.addEventListener("keydown", function (event) {
    if (
        event.key === "F12" ||
        // Windows keyboard shortcuts
        (event.ctrlKey && event.shiftKey && (event.key === "I" || event.key === "J" || event.key === "C")) ||
        // Mac keyboard shortcuts - Command + Option
        (event.metaKey && event.altKey && (event.key === "I" || event.key === "J" || event.key === "C")) ||
        // Mac keyboard shortcuts - Command + Shift
        (event.metaKey && event.shiftKey && (event.key === "I" || event.key === "J" || event.key === "C")) ||
        // Additional Mac keyboard shortcuts
        (event.metaKey && (event.key === "i" || event.key === "j" || event.key === "c" || event.key === "u"))
    ) {
        event.preventDefault();
        event.stopPropagation();
        alert("Developer tools are disabled!");
        return false;
    }
}, true);

document.addEventListener("DOMContentLoaded", function () {
    const goUpBtn = document.getElementById("back-top");

    goUpBtn.style.opacity = "0";
    goUpBtn.style.visibility = "hidden";

    window.addEventListener("scroll", function () {
        if (window.scrollY > 300) {
            goUpBtn.style.opacity = "1";
            goUpBtn.style.visibility = "visible";
        } else {
            goUpBtn.style.opacity = "0";
            goUpBtn.style.visibility = "hidden";
        }
    });

    goUpBtn.addEventListener("click", function () {
        window.scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
            goUpBtn.style.opacity = "0";
            goUpBtn.style.visibility = "hidden";
        }, 500);
    });
});
